export interface DocumentFilterInput {
  case_id: string;
  ids: [string];
}

export enum PipelineType {
  SCREENER = 'screener',
  DUEDILLIGENCE = 'due_diligence',
}

export interface DocumentAvailability {
  blob: boolean;
  embeddings: boolean;
}

export type DocumentData = {
  id: string;
  case_id: string;
  metadata: DocumentMetadata;
  availability: DocumentAvailability;
};

export interface DocumentMetadata {
  path: string;
  filename: string;
  filetype: string;
  size: number;
  type: string;
  subtype: string;
  uploaded_by: string;
  uploaded_date: string;
  case_id: string;
  org_id: string;
}

export enum DocumentSource {
  USER = 'user',
  COMPANY = 'company',
}
